import {
  BooleanCons,
  ImageType,
  NumberCons,
  StringConst,
} from 'src/app/constants/const';
import { BaseResponseHttp } from './commons.model';
import { CallPlace, IProducts } from './myActivity.model';

export class ContainerSelectorEstructor {
  data: Container;
  place: CallPlace;
  product: IProducts;
  productIndex: number;
  containerIndex: number;
  action: ContainerSelectorActions;
  containersInProduct: Array<string>;
  componentId: string;
  showMissingMesages: boolean;
  constructor() {
    this.place = CallPlace.default;
    this.data = new Container();
    this.product = new IProducts();
    this.productIndex = NumberCons.zero;
    this.containerIndex = NumberCons.zero;
    this.action = ContainerSelectorActions.changeContainer;
    this.containersInProduct = [];
    this.componentId = StringConst.empty;
    this.showMissingMesages = BooleanCons.true;
  }
}

export enum ContainerSelectorActions {
  changeContainer = 'change',
  addContainer = 'add',
}
export class Container {
  base?: string;
  activo?: string;
  description: string;
  value: string;
  type: string;
  itemException: string;
  clientException: string;
  imageUrl: string;
  price: number;
  isSelected: boolean;
  taxRate: number;
  priceWithIVA: number;
  priceWithDiscount: number;
  priceWithIvaDiscount?: number;
  containerHasMissing: boolean;
  arriveDateContainer: Date;
  itemCode: string;
  catalogGroup: string;
  constructor() {
    this.base = StringConst.empty;
    this.activo = StringConst.empty;
    this.description = StringConst.empty;
    this.value = StringConst.empty;
    this.type = StringConst.empty;
    this.itemException = StringConst.empty;
    this.clientException = StringConst.empty;
    this.imageUrl = StringConst.empty;
    this.price = NumberCons.zero;
    this.isSelected = BooleanCons.false;
    this.taxRate = NumberCons.zero;
    this.priceWithIVA = NumberCons.zero;
    this.priceWithDiscount = NumberCons.zero;
    this.containerHasMissing = BooleanCons.false;
    this.arriveDateContainer = new Date();
    this.itemCode = StringConst.empty;
    this.catalogGroup = StringConst.empty;
  }
}

export interface ContainerRespose extends BaseResponseHttp {
  response?: Container[];
}

export class RequestContainers {
  cardCode: string;
  itemCode: string;
  description: string;
  base?: string;
  clientType: string;
  priceListId: number;
  constructor() {
    this.cardCode = StringConst.empty;
    this.itemCode = StringConst.empty;
    this.description = StringConst.empty;
    this.clientType = StringConst.empty;
    this.priceListId = NumberCons.zero;
  }
}

export class ActiveContainer {
  product: IProducts;
  container: Container;
  callPlace: CallPlace;
  constructor() {
    this.product = new IProducts();
    this.container = new Container();
    this.callPlace = CallPlace.default;
  }
}

export class ImageViewerStructor {
  product: IProducts;
  callPlace: CallPlace;
  constructor() {
    this.product = new IProducts();
    this.callPlace = CallPlace.default;
  }
}
